import { PiSmileyXEyesFill } from 'react-icons/pi'
import ScreenContainer from './ScreenContainer'
import { Link } from 'react-router-dom'
import { size } from '@styles/theme'

const NoMatch = () => (
  <ScreenContainer>
    <div style={{ textAlign: 'center', marginTop: '7rem' }}>
      <PiSmileyXEyesFill size={size(12)} fill='#6A23FF' />
      <h2>This page does not exist.</h2>
      <p>You may <Link to={-1}>go back</Link> or <Link to='/map'>return home</Link>.</p>
    </div>
  </ScreenContainer>
)

export default NoMatch
